
    import {defineComponent, reactive, toRefs} from 'vue'
    import {useRouter} from "vue-router";

    interface State {
        titleText: string;
        isActive: boolean;
    }

    export default defineComponent({
        name: "pageTitle",
        props: {
            titleText: {
                type: String,
                default: ''
            },
            backFun: {
                type: String,
                default: ''
            }
        },
        setup(props: any,) {
            let state: State = reactive({
                titleText: '',
                isActive: false
            })
            // 获取路由器实例
            const router = useRouter();
            const {titleText} = toRefs(props);
            state.titleText = titleText
            if (state.titleText === '附加照片') {
                state.isActive = false
            } else {
                state.isActive = true
            }
            return {
                state,
                router
            }
        },
        methods: {
            goBack() {
                history.go(-1)
            }
        }
    })
